/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Error {
  error: { code: number; message: string; detail?: object };
}

export interface OmmitsSchema {
  numberOfMissedMessages: number;
  pollingTimeout: number;
}

export interface MessageSchema {
  messageId: number;
  datetime: string;
  authorId: number;
  type: "text" | "buttons";
  content: MessageContentTextSchema | MessageContentButtonsSchema;
  replyToMessage?: ReplyToMessageSchema;
}

export interface ReplyToMessageSchema {
  messageId: number;
  datetime: string;
  authorId: number;
  type: "text" | "buttons";
  content: MessageContentTextSchema | MessageContentButtonsSchema;
  replyMessageId?: number;
}

export interface MessageContentTextSchema {
  text: string;
}

export interface MessageContentButtonsSchema {
  text?: string;
  buttons: (MessageContentButtonSchema | MessageContentButtonLinkSchema)[][];
}

export interface MessageContentButtonSchema {
  title: string;
  callback: {
    step: string;
    scenario: string;
    notRequiredValue?: string;
    [key: string]: any;
  };
}

export interface MessageContentButtonLinkSchema {
  title: string;
  url: string;
}

export interface AuthorSchema {
  id: number;
  passport: { firstName: string; lastName: string; middleName: string };
  facilities: { role: string };
}

export interface MessageCreateResponseSchema {
  chatId: number;
  authorId: number;
  messageId: number;
  datetime: string;
  type: "text" | "button" | "file";
  content: ContentTypeText | ContentTypeButton | ContentTypeFile;
  replyToMessage?: ReplyToMessageSchema;
  author: {
    firstName: string;
    lastName: string;
    middleName: string;
    role: string;
  };
}

export interface ContentTypeText {
  text: string;
}

export interface ContentTypeButton {
  title: string;
  callback: { scenario: string; step: string; [key: string]: any };
}

export interface ContentTypeFile {
  text: string;
  file: { name: string; type: string; data: string };
}

export interface CreateTokenResponse {
  accessToken: string;
  chatId: string;
  userId: string;
}

export interface EventSchema {
  event:
    | "message_outgoing"
    | "message_incoming"
    | "message_update"
    | "opponents.last_read_message"
    | "opponents.typing_message";
  content:
    | EventMessageOutgoingData
    | EventMessageUpdateData
    | EventOpponentsTypingMessage;
}

export interface EventMessageOutgoingData {
  chatId: number;
  messages: Messages;
  authors: Authors;
}

export interface EventMessageUpdateData {
  chatId: number;
  messages: Messages;
  authors: Authors;
}

export interface EventOpponentsTypingMessage {
  chatId: number;
  userId: number;
}

export interface Message {
  messageId: number;
  authorId: number;
  datetime: string;
  type: string;
  content:
    | MessageContentText
    | MessageContentCommand
    | MessageContentButton
    | MessageContentCheckbox
    | MessageContentFile;
  replyToMessage?: ReplyToMessageSchema;
  traceId?: number | string | null;
}

export interface MessageContentText {
  /** @example привет */
  text: string;
}

export interface MessageContentCommand {
  /** @example /operator */
  text: string;
}

export interface MessageContentButton {
  /** @example 7 */
  butId: number;

  /** @example Мне понравилось! */
  title: string;
  callback: { step: string; scenario: string };
  [key: string]: any;
}

export type MessageContentCheckbox =
  | MessageContentCheckboxBot
  | MessageContentCheckboxUser;

export interface MessageContentCheckboxBot {
  /** @example За какой валютой следить ежедневно? */
  text?: string;
  checkboxTemplate: {
    title: string;
    states: { true: string; false: string; default: string };
    checkboxes?: { value: string }[][];
    controls?: {
      title: string;
      type: string;
      step?: string;
      scenario?: string;
    }[][];
  };
}

export interface MessageContentCheckboxUser {
  title: string;
  callback: {
    step: string;
    scenario?: string;
    checkboxes: { true: string[]; false: string[] };
  };
}

export interface MessageContentFile {
  /** @example посмотри файл */
  text?: string;
  file: {
    id: string;
    name: string;
    type: string;
    status: "check_for_viruses" | "clean" | "reject" | "done";
  };
  downloadUri?: string;
}

export type Messages = Message[];

export interface Author {
  id: string;
  passport: { firstName: string; lastName: string; middleName: string };
  facilities: { role: string };
}

export type Authors = Author[];

export interface ChatCreateResponse {
  chatId: number;
  totalReadMessageId: number;
}

export interface ErrorSchema {
  error: { code: number; message: string };
}

export interface MessageListResponseSchema {
  chatId: number;
  lastReadMessageId: number;
  messages: MessageSchema[];
  authors: AuthorSchema[];
}

export interface AuthenticatedUser {
  id: number;
  passport: { lastName: string; firstName: string; middleName: string };
  channel: {
    provider: { id: number; name: string };
    namespace: { id: number; name: string };
    externalRegistration?: boolean;
  };
  extras: Record<string, any>;
  facilities: { role: string; rights: Record<string, any> };
  session: Session;
}

export interface Session {
  access: SessionToken;
}

export interface SessionToken {
  token: string;
  exp: number;
}

export interface EventCreateBody {
  type: string;
  content: EventCreateContent;

  /** @example 2023-05-17 11:24:00.123 */
  datetime?: string;
}

export type EventCreateContent =
  | EventCreateContentOpponentsLastReadMessage
  | EventCreateContentOpponentsTypingMessage;

export interface EventCreateContentOpponentsLastReadMessage {
  userId: number;
  lastReadMessageId: number;
}

export interface EventCreateContentOpponentsTypingMessage {
  userId: number;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис webchat
 * @version 0.1.1
 * @baseUrl /web-bot
 *
 * Виджет web чата
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Возвращает объект пользователя.
     *
     * @tags Пользователи
     * @name V2GetUser
     * @summary Идентификация пользователя по токену
     * @request GET:/api/chats/v2/external/users
     * @secure
     */
    v2GetUser: (params: RequestParams = {}) =>
      this.request<AuthenticatedUser, Error>({
        path: `/api/chats/v2/external/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает объект пользователя.<br>Возможна аутентификация для незарегистрированного пользователя. Для этого необходимо убрать заголовок `Authorization` и обязательно заполнить параметр `channel`.
     *
     * @tags Пользователи
     * @name V2Auth
     * @summary Аутентификация пользователя по токену из большого приложения.
     * @request POST:/api/chats/v2/external/users/authentication
     * @secure
     */
    v2Auth: (
      query?: { channel?: "ul-lk" | "ul-site" | "ul-mobile" },
      params: RequestParams = {}
    ) =>
      this.request<AuthenticatedUser, Error>({
        path: `/api/chats/v2/external/users/authentication`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает идентификатор чата для отправки сообщений.
     *
     * @tags Чаты
     * @name V2ChatData
     * @summary Возвращает идентификатор чата
     * @request GET:/api/chats/v2/external/chats
     * @secure
     */
    v2ChatData: (params: RequestParams = {}) =>
      this.request<ChatCreateResponse, ErrorSchema | Error>({
        path: `/api/chats/v2/external/chats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Создаёт чат, если чат не существует.
     *
     * @tags Чаты
     * @name V2ChatCreateData
     * @summary Создать чат
     * @request POST:/api/chats/v2/external/chats
     * @secure
     */
    v2ChatCreateData: (params: RequestParams = {}) =>
      this.request<{ id: number }, ErrorSchema | Error>({
        path: `/api/chats/v2/external/chats`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправляет сообщение оппонентам по чату `chatId`
     *
     * @tags Сообщения
     * @name V2SendMessage
     * @summary Отправка сообщения в чат {chatId}
     * @request POST:/api/chats/v2/external/chats/{chatId}/messages
     * @secure
     */
    v2SendMessage: (
      chatId: string,
      data: {
        message: {
          type: "text" | "button" | "file";
          content: ContentTypeText | ContentTypeButton | ContentTypeFile;
          replyMessageId?: number;
          traceId?: number | string;
        };
      },
      params: RequestParams = {}
    ) =>
      this.request<MessageCreateResponseSchema, Error>({
        path: `/api/chats/v2/external/chats/${chatId}/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Выгрузка сообщений чата `chatId`.<br>Возможно задать количество выгружаемых сообщений с помощью параметра `limit`.<br>Пагинация реализована через указание идентификатор сообщения `messageId` и направления выгрузки `route`.
     *
     * @tags Сообщения
     * @name V2GetMessages
     * @summary Выгрузка сообщений из чата {chatId}
     * @request GET:/api/chats/v2/external/chats/{chatId}/messages
     * @secure
     */
    v2GetMessages: (
      chatId: string,
      query?: {
        messageId?: string;
        limit?: number;
        route?: "before" | "after" | "both";
      },
      params: RequestParams = {}
    ) =>
      this.request<MessageListResponseSchema, string | Error>({
        path: `/api/chats/v2/external/chats/${chatId}/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправляет файл и сообщение опонентам по чату `chatId`
     *
     * @tags Сообщения
     * @name V2SendMessageFile
     * @summary Отправка файла и сообщения в чат {chatId}
     * @request POST:/api/chats/v2/external/chats/{chatId}/messages/files
     * @secure
     */
    v2SendMessageFile: (
      chatId: string,
      data: {
        file: object;
        authorId: number;
        text?: string;
        replyMessageId?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<object, Error>({
        path: `/api/chats/v2/external/chats/${chatId}/messages/files`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Создаёт событие типа `type` в чате с идентификатором `chatId`.<br>Информация о событии передаётся в поле `content`.<br>Опционально можно указать `datetime`, если не будет указано - будет установлено текущее время.
     *
     * @tags События
     * @name V2CreateEvent
     * @summary Создать событие в чате {chatId}
     * @request POST:/api/chats/v2/external/chats/{chatId}/events
     * @secure
     */
    v2CreateEvent: (
      chatId: string,
      data: EventCreateBody,
      params: RequestParams = {}
    ) =>
      this.request<void, Error | string>({
        path: `/api/chats/v2/external/chats/${chatId}/events`,
        method: "POST",
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description ВНИМАНИЕ! Данный запрос не закрывается никогда (постоянное подключение, аналог WebSocket).<br>В ответе `200` указаны примеры событий (events), которые приходят с BackEnd. Все собятия приходят в JSON-формате.
     *
     * @tags Обновления с BackEnd
     * @name V2SseConnect
     * @summary SSE-подключение для принятия событий на BackEnd
     * @request GET:/api/chats/v2/external/updates/{userId}
     * @secure
     */
    v2SseConnect: (
      userId: string,
      query: { access_token: string },
      params: RequestParams = {}
    ) =>
      this.request<EventSchema, Error | string>({
        path: `/api/chats/v2/external/updates/${userId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description <p>Возвращает количество непрочитанных сообщений и время перерыва в секундах до следующего запроса.</p>
     *
     * @tags Обновления с BackEnd
     * @name V2GetOmits
     * @summary Количество непрочитанных сообщений и время следующего запроса
     * @request GET:/api/chats/v2/external/omits/{userId}
     * @secure
     */
    v2GetOmits: (
      userId: string,
      query: { chatId: string },
      params: RequestParams = {}
    ) =>
      this.request<OmmitsSchema, Error | void>({
        path: `/api/chats/v2/external/omits/${userId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает файл с идентификатором `fileId`.
     *
     * @tags Файлы
     * @name V2GetFile
     * @summary Возвращает файл.
     * @request GET:/api/chats/v2/external/media/{fileId}
     * @secure
     */
    v2GetFile: (fileId: string, params: RequestParams = {}) =>
      this.request<void, string>({
        path: `/api/chats/v2/external/media/${fileId}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
}

export const api = new Api();
